import React, { useState, useEffect } from 'react'
import { Tree, Input } from 'antd'
import styled from 'styled-components'
import { SearchOutlined } from '@ant-design/icons'
const { Search } = Input
import { PlusOutlined } from '@ant-design/icons'
import { getCookie } from 'helper/cookie'
const HolidayContainer = styled.div``
let firsttimein = true
const TreeComponent = (props) => {
  const {
    treeCompany,
    setLevel_ID,
    setLevel,
    eventAdd,
    setCheckByID,
    setCompanyID,
    setCheckChangeTable,
    checkChangeTable,
  } = props

  const token = getCookie('access_token_admin')
  const [expandedKeys, setExpandedKeys] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const [autoExpandParent, setAutoExpandParent] = useState(true)
  const [selectedKeys, setSelectedKeys] = useState()

  useEffect(() => {
    // if (firsttimein == true && treeCompany.length > 0) {
    if (treeCompany.length > 0) {
      setExpandedKeys(['key_company'])
      setSelectedKeys([treeCompany[0].key])
      setCompanyID(treeCompany[0].id)
    } else {
      setExpandedKeys(expandedKeys)
      setSelectedKeys(selectedKeys)
    }
  }, [treeCompany])

  const dataList = []
  //นำ data ที่เป็น tree มาแยกออกให้เป็นของตัวมันเอง
  const generateList = (data) => {
    for (let i = 0; i < data.length; i++) {
      const node = data[i]
      const { key } = node
      dataList.push({ key, title: key })
      if (node.children) {
        generateList(node.children)
      }
    }
  }
  generateList(treeCompany)

  const getParentKey = (key, tree) => {
    let parentKey
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children)
        }
      }
    }
    return parentKey
  }

  //จังหวะ click จะให้ตัวไหนเปิดบ้าง
  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys)
    setAutoExpandParent(false)
  }

  const onChange = (e) => {
    const { value } = e.target
    const expandedKeys = dataList.map((item) => {
      if (item?.title?.toLowerCase()?.includes(value?.toLowerCase())) {
        //ถ้าคำตรงกันให้ไปหาตัวแม่ของมัน
        return getParentKey(item.key, treeCompany)
      }
      return null
    })
    setExpandedKeys(expandedKeys)
    setSearchValue(value)
    setAutoExpandParent(true)
  }

  const onClickPlus = (level_id, company_id) => {
    setLevel_ID(level_id)
    setLevel(1)
    setCompanyID(company_id)
    setCheckChangeTable(checkChangeTable + 1)
    eventAdd(company_id)
  }

  const [checkSearch, setCheckSearch] = useState([])

  const [displayTree, setDisplayTree] = useState(true)

  let arr = []

  const checkDataSearch = async (data) => {
    await data.map((item) => {
      const index = item.title.toLowerCase().includes(searchValue.toLowerCase())
      arr.push(index)

      if (item.children) {
        return {
          key: item.key,
          children: checkDataSearch(item.children),
          level: item.level,
          level_id: item.level_id,
          id: item.id,
          item: item,
        }
      }
    })
    setCheckSearch(arr)
  }

  useEffect(() => {
    let havedata = false
    checkSearch.map((item) => {
      if (item == true) {
        havedata = true
      }
    })
    if (checkSearch.length == 0) {
      setDisplayTree(true)
    } else {
      setDisplayTree(havedata)
    }
  }, [checkSearch])

  useEffect(() => {
    arr = []
    checkDataSearch(treeCompany)
  }, [searchValue])

  const loop = (data) =>
    data.map((item) => {
      const index = item.title.toLowerCase().includes(searchValue.toLowerCase())
      let code = item.title.split(' ')
      let company = []
      code.map((item, index) => {
        if (index != 0) {
          company.push(item)
        }
      })

      let companyName = company.join(' ')
      const title =
        //ถ้า index เป็น -1 คือ ไม่เจอค่า
        item.title == 'Impact Type' ? (
          <span>
            <span>{item.title}</span>
            <span
              onClick={() => onClickPlus(item.level_id, item.company_id, item.key)}
              style={{ marginLeft: 50 }}
            >
              <PlusOutlined />
            </span>
          </span>
        ) : index == true && searchValue !== '' ? (
          <span
            className="event-search-tree-container"
            style={{
              display: 'flex',
              alignItems: 'center',

              marginTop: 4.5,
            }}
          >
            {/* เจอ */}
            <h5 className="code-tree-style">{code[0]}</h5>
            <h5
              className="title-cut"
              style={{
                marginLeft: 8,
                background: 'rgba(18, 126, 195, 0.16)',
                padding: '0px 4px 0px 4px',
                borderRadius: 16,
              }}
            >
              {companyName}
            </h5>
          </span>
        ) : (
          // ไม่เจอ
          <span
            className="event-search-tree-container"
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 4.5,
            }}
          >
            <h5 className="code-tree-style">{code[0]}</h5>
            <h5 className="title-cut" style={{ marginLeft: 8 }}>
              {companyName}
            </h5>
          </span>
        )

      //ถ้ามี ใน item นั้นมี children ให้วนลูป ไปค้นหาใหม่
      if (item.children) {
        return {
          title,
          key: item.key,
          children: loop(item.children),
          level: item.level,
          level_id: item.level_id,
          id: item.id,
          item: item,
        }
      }

      return {
        title,
        key: item.key,
        level: item.level,
        level_id: item.level_id,
        id: item.id,
        item: item,
      }
    })

  const onClick = (e, value) => {
    setSelectedKeys([value.item.key])
    setExpandedKeys((prev) => [...prev, value.item.key])
    firsttimein = false
    setCompanyID(value.item.id)
    setCheckByID(false)
  }

  return (
    <HolidayContainer>
      <div>
        {/* <div
          style={{
            marginTop: 32,
            marginBottom: 32,
            marginLeft: 16,
            marginRight: 16,
          }}
        >
          <Input
            placeholder='Search'
            suffix={<SearchOutlined style={{ fontSize: 20 }} />}
            allowClear
            onChange={onChange}
            size='large'
          />
        </div> */}
        <Tree
          style={{ display: displayTree ? _ : 'none' }}
          onExpand={onExpand}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
          treeData={loop(treeCompany)}
          onClick={(e, value) => onClick(e, value)}
          selectedKeys={selectedKeys}
        />
      </div>
    </HolidayContainer>
  )
}
export default TreeComponent
